"use client"
import React from 'react'
import styles from './index.module.scss'
import { pushToDataLayer } from '@/helpers/gtag'
import { getGlobalStateValue } from '@/context/utils'

const ExploreProgramsBtn = () => {
const handleProgramsGA=()=>{
    pushToDataLayer({
        cta_text: "EXPLORE PROGRAMS",
        event: "banner_course_interaction",
      })
}
  return (
    <a href="/programs" onClick={()=>handleProgramsGA()} className={styles.exploreBtn}>Explore Programs</a>
  )
}

const ExploreScholarshipBtn = () => {
const handleGAScholarship=()=>{
    pushToDataLayer({
        cta_text: "CHECK ELIGIBILITY",
        event: "banner_course_interaction",
      })
}
  return (
    <a href="/scholarship" onClick={()=>handleGAScholarship()} className={styles.chckEligibility}>Check Eligibility</a>
  )
}

export {ExploreProgramsBtn,ExploreScholarshipBtn};
